import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { getDynamicMemberData, getDynamicMemberITINData } from "./constants";

export const getToken = () => {
  return localStorage.getItem("user_token");
};

export const removeToken = () => {
  localStorage.removeItem("user_token");
};

export const setUserData = (userData: any) => {
  localStorage.setItem("user_data", JSON.stringify(userData));
};
export const roleId = Number(localStorage.getItem("roleId"));
export const userId = Number(localStorage.getItem("userId"));
export const fullname: string = localStorage.getItem("firstName") ?? "";
export const lastName: string = localStorage.getItem("lastName") ?? "";
export const localName: string = `${fullname} ${lastName}`.trim();
export const getUserData = () => {
  const data = localStorage.getItem("user_data");

  return data ? JSON.parse(data) : null;
};

export const clearUserData = () => {
  localStorage.removeItem("user_token");
  localStorage.removeItem("user_data");
};




export const handlDownoad = async (
      fileUrl: string,
      fileName: string = "document.pdf"
    ) => {
      try {
        // setDownloadingFile(fileUrl);
        // download(fileUrl, fileName);
        const response = await fetch(fileUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/octet-stream",
          },
        });
  
        if (!response.ok) {
          throw new Error("Failed to fetch file");
        }
  
        const reader = response.body?.getReader();
        if (!reader) {
          throw new Error("Failed to get stream reader");
        }
  
        const stream = new ReadableStream({
          async start(controller) {
            while (true) {
              const result = await reader.read();
              if (result.done) break;
              controller.enqueue(result.value);
            }
            controller.close();
            reader.releaseLock();
          },
        });
  
        const blob = await new Response(stream).blob();
        const blobUrl = window.URL.createObjectURL(blob);
  
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
  
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        window.open(fileUrl, "_blank");
      } finally {
        // setDownloadingFile(null);
      }
    
  
}

/************************************** * pdf converter function *****************************************/
// export const generatePDF = () => {
//   const input: any = document.getElementById("pdf-content"); // The div you want to capture

//   html2canvas(input, {
//     scale: 2, // ⬆ Increased scale (DPI) for better quality (Try 3 or 4)
//     useCORS: true, // To load external images properly
//   }).then((canvas) => {
//     const imgData = canvas.toDataURL("image/png");
//     const pdf = new jsPDF("p", "mm", "a4");

//     const imgWidth = 210; // A4 size width in mm
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;

//     pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
//     pdf.save("download.pdf");
//   });
// };

export const generatePDF = () => {
  const input: HTMLElement | null = document.getElementById("pdf-content");
  if (!input) return;

  html2canvas(input, {
    scale: 2, // Higher scale for better quality
    useCORS: true, // Ensures external images load properly
  }).then((canvas) => {
    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = 210; // A4 width in mm
    const pageHeight = 260; // A4 height in mm

    const paddingX = 10; // Left and right padding in mm
    const paddingY = 10; // Top and bottom padding in mm

    const contentWidth = pageWidth - paddingX * 2; // Adjusted width with padding
    const scaleRatio = contentWidth / canvas.width; // Scaling factor

    const scaledHeight = canvas.height * scaleRatio; // Scaled content height
    const pageCanvasHeight = (pageHeight - paddingY * 2) / scaleRatio; // Max height per page

    let position = 0;

    while (position + pageCanvasHeight <= canvas.height) {
      const pageCanvas = document.createElement("canvas");
      const pageContext = pageCanvas.getContext("2d");

      pageCanvas.width = canvas.width;
      pageCanvas.height = pageCanvasHeight;

      if (pageContext) {
        pageContext.drawImage(
          canvas,
          0,
          position,
          canvas.width,
          pageCanvasHeight,
          0,
          0,
          canvas.width,
          pageCanvasHeight
        );

        const pageImage = pageCanvas.toDataURL("image/png");
        pdf.addImage(
          pageImage,
          "PNG",
          paddingX, // Add padding on X-axis
          paddingY, // Add padding on Y-axis
          contentWidth, // Adjusted width
          pageHeight // Adjusted height
        );

        position += pageCanvasHeight;

        if (position < canvas.height) pdf.addPage();
      }
    }

    // Handle the last portion if the content doesn’t fit perfectly
    if (position < canvas.height) {
      const lastPageCanvas = document.createElement("canvas");
      const lastPageContext = lastPageCanvas.getContext("2d");

      lastPageCanvas.width = canvas.width;
      lastPageCanvas.height = canvas.height;

      if (lastPageContext) {
        lastPageContext.drawImage(
          canvas,
          0,
          position,
          canvas.width,
          lastPageCanvas.height,
          0,
          0,
          canvas.width,
          lastPageCanvas.height
        );

        const lastPageImage = lastPageCanvas.toDataURL("image/png");
        pdf.addImage(
          lastPageImage,
          "PNG",
          paddingX,
          paddingY,
          contentWidth,
          (lastPageCanvas.height * contentWidth) / canvas.width
        );
      }
    }

    pdf.save("form_2848");
  });
};
export const generatePDFd = () => {
  const input: HTMLElement | null = document.getElementById("pdf-content");
  if (!input) return;

  html2canvas(input, {
    scale: 2, // Higher scale for better quality
    useCORS: true, // Ensures external images load properly
  }).then((canvas) => {
    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = 210; // A4 width in mm
    const pageHeight = 260; // A4 height in mm

    const paddingX = 10; // Left and right padding in mm
    const paddingY = 15; // Top and bottom padding in mm

    const contentWidth = pageWidth - paddingX * 2; // Adjusted width with padding
    const scaleRatio = contentWidth / canvas.width; // Scaling factor

    const scaledHeight = canvas.height * scaleRatio; // Scaled content height
    const pageCanvasHeight = (pageHeight - paddingY * 2) / scaleRatio; // Max height per page

    let position = 0;

    while (position + pageCanvasHeight <= canvas.height) {
      const pageCanvas = document.createElement("canvas");
      const pageContext = pageCanvas.getContext("2d");

      pageCanvas.width = canvas.width;
      pageCanvas.height = pageCanvasHeight;

      if (pageContext) {
        pageContext.drawImage(
          canvas,
          0,
          position,
          canvas.width,
          pageCanvasHeight,
          0,
          0,
          canvas.width,
          pageCanvasHeight
        );

        const pageImage = pageCanvas.toDataURL("image/png");
        pdf.addImage(
          pageImage,
          "PNG",
          paddingX, // Add padding on X-axis
          paddingY, // Add padding on Y-axis
          contentWidth, // Adjusted width
          pageHeight // Adjusted height
        );

        position += pageCanvasHeight;

        if (position < canvas.height) pdf.addPage();
      }
    }

    // Handle the last portion if the content doesn’t fit perfectly
    if (position < canvas.height) {
      const lastPageCanvas = document.createElement("canvas");
      const lastPageContext = lastPageCanvas.getContext("2d");

      lastPageCanvas.width = canvas.width;
      lastPageCanvas.height = canvas.height;

      if (lastPageContext) {
        lastPageContext.drawImage(
          canvas,
          0,
          position,
          canvas.width,
          lastPageCanvas.height,
          0,
          0,
          canvas.width,
          lastPageCanvas.height
        );

        const lastPageImage = lastPageCanvas.toDataURL("image/png");
        pdf.addImage(
          lastPageImage,
          "PNG",
          paddingX,
          paddingY,
          contentWidth,
          (lastPageCanvas.height * contentWidth) / canvas.width
        );
      }
    }

    pdf.save("form_2848");
  });
};

export const imgUrl = process.env.REACT_APP_BASE_IMAGE_URL;

// Tax Filing Calculation Functions
export const calculateTaxFilingTotal = (formik: any, hasITIN: boolean = false, empty: boolean = false) => {
  const baseTotal = empty ? 298.00 : 498.00;
  const multiMembersFee = formik.values.multi_members == true ? 200 : 0;
  const itinFee = hasITIN ? 100 : 0;
 
  // Calculate CorpData pricing using dynamic pricing
  const getTotalMembersPrice = () => {
    
    // Get the selected member value from formik
    const selectedMemberValue = formik.values.total_members;
    if (!selectedMemberValue) return 0;
    
    // Find the selected member from the dynamic data
    const dynamicData = getDynamicMemberData();
    const selectedMember = dynamicData.find(member => member.value === selectedMemberValue);
    return selectedMember ? selectedMember.price : 0;
  };

  const getTotalMembersITINPrice = () => {
    const selectedITINValue = formik.values.total_members_itin;
    if (!selectedITINValue) return 0;
    
    // Find the selected ITIN from the dynamic data
    const dynamicITINData = getDynamicMemberITINData();
    const selectedITIN = dynamicITINData.find(itin => itin.value === selectedITINValue);
    return selectedITIN ? (selectedITIN.price || 0) : 0;
  };

  const corpDataTotal = getTotalMembersPrice() + getTotalMembersITINPrice();
  // console.log(corpDataTotal,"corpDataTotal",baseTotal, multiMembersFee, itinFee)
  return baseTotal + multiMembersFee + itinFee ;
};

export const calculateCorpDataTotal = (formik: any,baseTotal: number = 898.00) => {
  const getTotalMembersPrice = () => {
    const selectedMemberValue = formik.values.total_members;
    if (!selectedMemberValue) return 0;
    
    // Extract member count from the selected value text (e.g., "Add 6 Members" -> 6)
    const memberCountMatch = selectedMemberValue.match(/Add (\d+) Member/);
    if (!memberCountMatch) return 0;
    
    const memberCount = parseInt(memberCountMatch[1]);
    
    // Find the member data by ID (which corresponds to the member count)
    const dynamicData = getDynamicMemberData();
    const selectedMember = dynamicData.find(member => member.id === memberCount);
    return selectedMember ? selectedMember.price : 0;
  };

  const getTotalMembersITINPrice = () => {
    const selectedITINValue = formik.values.total_members_itin;
    if (!selectedITINValue) return 0;
    
    // Extract ITIN count from the selected value text (e.g., "Add 3 ITINs" -> 3)
    const itinCountMatch = selectedITINValue.match(/Add (\d+) ITIN/);
    if (!itinCountMatch) {
      // Check if it's "All members already have an ITIN"
      if (selectedITINValue.includes("All members already have an ITIN")) {
        const dynamicITINData = getDynamicMemberITINData();
        const selectedITIN = dynamicITINData.find(itin => itin.id === 1);
        return selectedITIN ? (selectedITIN.price || 0) : 0;
      }
      return 0;
    }
    
    const itinCount = parseInt(itinCountMatch[1]);
    
    // Find the ITIN data by ID (ID 2 corresponds to "Add 1 ITIN", ID 3 to "Add 2 ITINs", etc.)
    const dynamicITINData = getDynamicMemberITINData();
    const selectedITIN = dynamicITINData.find(itin => itin.id === itinCount + 1);
    return selectedITIN ? (selectedITIN.price || 0) : 0;
  };

  return  (getTotalMembersITINPrice() || 0);
};


